var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.4 27.5H153.3v104.1c-10.3 1.9-18 2.7-26.2 2.7-24.7 0-37.7-11.2-37.7-32.9 0-20.8 13.9-34.3 35.5-34.3 3.3 0 6.3.3 9.9 1.1V27.9c-3.2-.7-7.6-0.9-11.8-0.9-36.8 0-57.1 22.8-57.1 63.1 0 39.2 19.5 60.5 57.9 60.5 10.8 0 21.8-1.1 32-3.1V27.5z",
    fill: "#092E20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.7 75.2v60.6c0 20.8-1.5 30.9-6.1 39.5-4.2 8.3-9.8 13.8-21.4 19.7L148 181.4c11.6-5.4 17.1-10.1 20.8-17.4 3.8-7.5 5-16.3 5-39.3V75.2h30.9zM204.2 27.5H173v33.8h31.2V27.5z",
    fill: "#092E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.ab82922707c401c1126ab760a9d07bb5.svg";
export { ForwardRef as ReactComponent };